// |-- Built-in Dependencies --|
import React from "react";

// |-- External Dependencies --|
import { boolean, object, string } from "yup";
import { Formik, FormikHelpers } from "formik";
import Dialog from "@mui/material/Dialog";

// |-- Internal Dependencies --|
import ExpenseForm from "../Layout/ExpenseForm";
import { useAddExpensesMutation } from "src/services/ExpensesServices";
import { showToast } from "src/utils/showToaster";
import { ExpenseFormValues } from "src/models/Expense.model";
import moment from "moment";

// |-- Types --|
type Props = {
  onClose: () => void;
};

const AddExpenseFormWrapper = ({ onClose }: Props) => {
  const [addExpenses] = useAddExpensesMutation();
  const initialValues: ExpenseFormValues = {
    amount: "",
    categoryId: "",
    expense_on_date: null,
    accountId: "",
    branchId: "",
    remark: "",
    will_return: false,
    return_date: null,
    return_remark: "",
    return_amount: "",
  };
  const validationSchema = object({
    amount: string().required("Please enter amount"),
    categoryId: object().required("Please select category"),
    accountId: object().required("Please select account"),
    branchId: object().required("Please select branch"),
    remark: string().required("Please enter remark"),
    expense_on_date: string().required("Please select date"),
    will_return: boolean(),
  });

  const onSubmitHandler = (
    values: any,
    { setSubmitting, resetForm }: FormikHelpers<any>
  ) => {
    const formattedValues = {
      categoryId: values?.categoryId?.value,
      accountId: values?.accountId?.value,
      expense_on_date: values?.expense_on_date
        ? moment(values?.expense_on_date).format("YYYY-MM-DD")
        : "",
      branchId: values?.branchId?.value,
      amount: parseInt(values.amount),
      remark: values.remark,
      will_return: values?.will_return,
      return_date: values?.return_date === null ? "" : values?.return_date,
      return_remark: values?.return_remark,
      willReturnAmount:
        values?.return_amount === ""
          ? parseInt(values.amount)
          : values?.return_amount,
    };
    addExpenses(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          onClose();
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmitHandler}
      >
        {(formikProps) => {
          return (
            <ExpenseForm
              formType="Add"
              onClose={onClose}
              formikProps={formikProps}
            />
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default AddExpenseFormWrapper;
